// 沙巴州球场数据
// Sabah Golf Courses

export const SABAH_COURSES = {
  "DALIT_BAY_GOLF_AND_COUNTRY_CLUB": {
    shortName: "DBGCC",
    fullName: "Dalit Bay Golf & Country Club",
    location: ["Tuaran", "Sabah", "Malaysia"],
    pars: [4,4,5,3,5,4,4,3,4, 4,3,5,4,5,4,4,3,4],
    index: [17,7,5,15,9,13,3,11,1, 16,18,8,2,6,4,14,12,10]
  },

  "KENINGAU_GOLF_AND_COUNTRY_CLUB": {
    shortName: "KGCC",
    fullName: "Keningau Golf & Country Club",
    location: ["Keningau", "Sabah", "Malaysia"],
    pars: [4,3,4,4,3,5,4,4,5, 4,5,3,4,4,3,4,4,5],
    index: [2,18,14,12,16,8,6,4,10, 11,3,15,17,7,13,9,5,1]
  },

  "KINABALU_GOLF_CLUB": {
    shortName: "KGC",
    fullName: "Kinabalu Golf Club",
    location: ["Tanjung Aru", "Sabah", "Malaysia"],
    pars: [4,4,4,4,3,4,5,3,4],
    index: [5,7,6,2,8,3,1,4,9]
  },

  "KUDAT_GOLF_AND_MARINA_RESORT": {
    shortName: "KGMR",
    fullName: "Kudat Golf & Marina Resort",
    location: ["Kudat", "Sabah", "Malaysia"],
    pars: [4,4,4,5,3,4,4,3,5, 4,3,5,4,3,4,4,4,5],
    index: [10,8,2,14,16,4,6,18,12, 11,13,1,7,17,3,15,5,9]
  },

  "LAHAD_DATU_GOLF_AND_COUNTRY_CLUB": {
    shortName: "LDGCC",
    fullName: "Lahad Datu Golf & Country Club",
    location: ["Lahad Datu", "Sabah", "Malaysia"],
    pars: [4,3,4,5,4,4,5,3,4, 4,4,5,3,5,3,4,4,4],
    index: [17,15,13,1,7,9,3,11,5, 10,16,4,18,2,12,6,8,14]
  },

  "MOUNT_KINABALU_GOLF_CLUB": {
    shortName: "MKGC",
    fullName: "Mount Kinabalu Golf Club",
    location: ["Kundasang", "Sabah", "Malaysia"],
    pars: [5,4,4,3,5,4,4,3,4, 4,4,4,5,3,5,3,4,4],
    index: [16,14,2,18,10,12,6,8,4, 7,9,17,1,13,5,15,3,11]
  },

  "NEXUS_GOLF_RESORT_KARAMBUNAI": {
    shortName: "NGRK",
    fullName: "Nexus Golf Resort Karambunai",
    location: ["Kota Kinabalu", "Sabah", "Malaysia"],
    pars: [5,4,3,4,3,4,4,4,5, 4,4,3,5,4,4,3,5,4],
    index: [2,10,18,6,14,16,12,4,8, 13,3,7,1,17,5,15,11,9]
  },

  "RANAU_GOLF_AND_COUNTRY_CLUB": {
    shortName: "RGCC",
    fullName: "Ranau Golf & Country Club",
    location: ["Ranau", "Sabah", "Malaysia"],
    pars: [4,4,3,5,4,4,3,5,4],
    index: [7,2,9,6,5,4,8,1,3]
  },

  "SABAH_GOLF_AND_COUNTRY_CLUB": {
    shortName: "SGCC",
    fullName: "Sabah Golf & Country Club",
    location: ["Kota Kinabalu", "Sabah", "Malaysia"],
    pars: [4,5,4,4,3,5,4,3,4, 4,4,3,4,5,4,4,3,5],
    index: [8,2,14,12,18,6,4,16,10, 11,5,17,15,1,7,3,13,9]
  },

  "SANDAKAN_GOLF_AND_COUNTRY_CLUB": {
    shortName: "SGCC",
    fullName: "Sandakan Golf & Country Club",
    location: ["Sandakan", "Sabah", "Malaysia"],
    pars: [4,4,5,4,3,5,4,3,4, 4,3,4,5,3,5,4,4,4],
    index: [8,18,14,2,12,6,10,16,4, 9,17,1,7,15,11,3,13,5]
  },

  "SHANSHUI_GOLF_AND_COUNTRY_CLUB": {
    shortName: "SGCC",
    fullName: "Shan Shui Golf & Country Club",
    location: ["Tawau", "Sabah", "Malaysia"],
    pars: [4,4,3,4,5,4,5,3,4, 5,4,4,5,3,4,3,4,4],
    index: [17,13,15,3,5,11,9,7,1, 4,14,2,8,18,10,16,6,12]
  },

  "SIBUGA_GOLF_CLUB": {
    shortName: "SGC",
    fullName: "Sibuga Golf Club",
    location: ["Sandakan", "Sabah", "Malaysia"],
    pars: [5,4,4,3,4,4,4,3,3],
    index: [,,,,,,,,, ,,,,,,,,]
  },

  "SIGALONG_GOLF_AND_COUNTRY_CLUB": {
    shortName: "SGCC",
    fullName: "Sigalong Golf & Country Club",
    location: ["Semporna", "Sabah", "Malaysia"],
    pars: [4,4,3,4,5,3,5,4,4, 4,4,4,5,4,5,3,4,3],
    index: [17,7,15,9,1,11,5,17,13, 8,4,12,6,2,4,14,16,10]
  },

  "SUTERA_HARBOUR_GOLF_AND_COUNTRY_CLUB_HERITAGE_GARDEN": {
    shortName: "SHGCC-HG",
    fullName: "Sutera Harbour Golf & Country Club (Heritage + Garden)",
    location: ["Kota Kinabalu", "Sabah", "Malaysia"],
    pars: [4,5,4,4,4,3,4,3,5, 5,3,4,3,4,4,5,4,4],
    index: [15,3,5,1,13,11,9,17,7, 4,16,2,18,14,12,8,10,6]
  },

  "SUTERA_HARBOUR_GOLF_AND_COUNTRY_CLUB_LAKES_GARDEN": {
    shortName: "SHGCC-LG",
    fullName: "Sutera Harbour Golf & Country Club (Lakes + Garden)",
    location: ["Kota Kinabalu", "Sabah", "Malaysia"],
    pars: [5,3,4,4,4,5,3,4,4, 5,3,4,3,4,4,5,4,4],
    index: [14,16,10,4,12,2,18,6,8, 3,15,1,17,13,11,7,9,5]
  },

  "SUTERA_HARBOUR_GOLF_AND_COUNTRY_CLUB_LAKES_HERITAGE": {
    shortName: "SHGCC-LH",
    fullName: "Sutera Harbour Golf & Country Club (Lakes + Heritage)",
    location: ["Kota Kinabalu", "Sabah", "Malaysia"],
    pars: [5,3,4,4,4,5,3,4,4, 4,5,4,4,4,3,4,3,5],
    index: [13,15,9,3,11,1,17,5,7, 16,4,6,2,14,12,10,18,8]
  },

  "TAMBUNAN_GOLF_CLUB": {
    shortName: "TGC",
    fullName: "Tambunan Golf Club",
    location: ["Tambunan", "Sabah", "Malaysia"],
    pars: [5,4,5,4,3,4,4,4,3, 4,4,4,5,4,4,3,3,5],
    index: [12,14,2,4,18,8,10,6,16, 9,11,13,1,5,7,17,15,3]
  },

  "TAWAU_GOLF_CLUB_HOT_SPRING": {
    shortName: "TGC-HS",
    fullName: "Tawau Golf Club (Hot Spring Course)",
    location: ["Tawau", "Sabah", "Malaysia"],
    pars: [4,4,4,3,5,3,4,5,4, 4,4,3,5,4,4,4,3,5],
    index: [1,9,11,13,15,17,7,3,5, 6,8,12,4,10,16,18,14,2]
  }
};

export default SABAH_COURSES;
